'use strict';
module.exports = require('./Dropdown.vue');